/**
 * Converts a string into Capitalize
 *
 * @param value
 * @returns {string}
 */
export const capitalize = value => (value || value === 0) ? String(value).charAt(0).toUpperCase() + String(value).slice(1) : ''
